/** @format */

import { useRef, useState, useEffect } from 'react';
import { Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import Category from './Category/Index';
import Product from './Product/Index';
import api from '../shared/utils/auth/Index';
import Order from './Order/Index';
import { useRole } from '../shared/hooks/CustomHooks';
import { useContext } from 'react';
import { MorabishoooContext } from '../Contexts/MorabishoooContext';
import Loader from '../shared/components/Loader';

const ProtectedRoutes = () => {
	const morabishoooContext = useContext(MorabishoooContext);
	const [loading, setLoading] = useState(false);
	const { can } = useRole();

	useEffect(() => {
		const getUser = async () => {
			setLoading(true);
			await api.get(
				'/auth/me',
				{},
				(res) => {
					morabishoooContext.authUser = res.data.data;
					morabishoooContext.authRoles = res.data.data.roles;
					setLoading(false);
				},
				(err) => {
					setLoading(false);
					console.log(err);
				},
			);
		};
		getUser();
	}, []);

	return loading ? (
		<Loader />
	) : (
		<>
			{can('Super Admin') && (
				<>
					<Route exact path='/' component={Dashboard} />
					<Route path='/categories' component={Category} />
					<Route path='/products' component={Product} />
					<Route path='/order' component={Order} />
				</>
			)}
		</>
	);
};

export default ProtectedRoutes;
